import { useDispatch, useSelector } from "react-redux"

function visiblePages(totalPages, currentPage) {
    if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, index) => index)
    }

    const pages = new Set([0, totalPages - 1, currentPage - 1, currentPage, currentPage + 1])

    if (currentPage < 3) {
        pages.add(1)
        pages.add(2)
        pages.add(3)
    }

    if (currentPage > totalPages - 4) {
        pages.add(totalPages - 2)
        pages.add(totalPages - 3)
        pages.add(totalPages - 4)
    }

    return [...pages]
        .filter(page => page >= 0 && page < totalPages)
        .sort((a, b) => a - b)
}

export function DashboardPagination({ totalPages, currentPage = 0, onPageChange, label = "Pagination" }) {
    if (totalPages <= 1) {
        return null
    }

    const activePage = Math.min(Math.max(currentPage, 0), totalPages - 1)
    const pages = visiblePages(totalPages, activePage)
    const items = []

    pages.forEach((page, index) => {
        if (index > 0 && page - pages[index - 1] > 1) {
            items.push(<span className="dashboard-pagination__ellipsis" aria-hidden="true" key={`ellipsis-${page}`}>…</span>)
        }

        items.push(
            <button
                type="button"
                className={`dashboard-pagination__page${page === activePage ? " active" : ""}`}
                aria-current={page === activePage ? "page" : undefined}
                aria-label={`Seite ${page + 1}`}
                onClick={() => onPageChange(page)}
                key={page}
            >
                {page + 1}
            </button>
        )
    })

    return <nav className="dashboard-pagination" aria-label={label}>
        <button
            type="button"
            className="dashboard-pagination__nav"
            disabled={activePage === 0}
            aria-label="Vorherige Seite"
            onClick={() => onPageChange(activePage - 1)}
        >
            <span aria-hidden="true">‹</span><span className="dashboard-pagination__nav-label">Zurück</span>
        </button>
        <div className="dashboard-pagination__pages">{items}</div>
        <button
            type="button"
            className="dashboard-pagination__nav"
            disabled={activePage === totalPages - 1}
            aria-label="Nächste Seite"
            onClick={() => onPageChange(activePage + 1)}
        >
            <span className="dashboard-pagination__nav-label">Weiter</span><span aria-hidden="true">›</span>
        </button>
    </nav>
}

export function StorePagination({ index, sliceName, actions, label }) {
    if (index !== 0) {
        return null
    }

    return <ConnectedStorePagination sliceName={sliceName} actions={actions} label={label} />
}

function ConnectedStorePagination({ sliceName, actions, label }) {
    const dispatch = useDispatch()
    const pagination = useSelector(state => state[sliceName].pagination)
    const selectedPage = useSelector(state => state[sliceName].selectedpagination)

    if (!pagination) {
        return null
    }

    return <DashboardPagination
        totalPages={pagination.length}
        currentPage={selectedPage}
        label={label}
        onPageChange={page => {
            dispatch(actions.setFilteredItems(pagination[page]))
            dispatch(actions.setSelectedPagination(page))
        }}
    />
}
